export default __webpack_public_path__ + "static/media/Track_poscorad_2.3383c771.gif";